import { AppBar, Grid, IconButton, List, Slide, SlideProps, Toolbar, Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import MuiDialog from "@material-ui/core/Dialog";
import ChevronRight from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/KeyboardArrowDown";
import ExpandLessIcon from "@material-ui/icons/KeyboardArrowUp";
import mypaps_logo from "assets/icons/MYPAPSLOGO.svg";
import papsChristmasLogo from "assets/icons/MyPaps_Noel_White.svg";
import AvatarIcon from "assets/images/team-3@3x.png";
import { StyledBadge } from "components/NotificationPopUp";
import i18n from "config/i18n";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { useNotification } from "contexts/NotificationContext";
import { useCurrentUser } from "hooks/useCurrentUser";
import { BoxesIcon, BoxNewIcon, DashIcon, GiftIcon, HistoryIcon, LogOutIcon, PersonIcon, RingIcon } from "icons";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StyledCheckbox from "ui/Checkbox";
import { CollapseItem, MenuItem, useNavStyles } from "./styles";

interface DialogProps {
  open: boolean;
  handleClose: () => void;
}
const SlideTransition: any = React.forwardRef<unknown, SlideProps>((props, ref) => (
  <Slide direction="right" ref={ref} {...props} />
));

interface GroupMenuProps {
  icon?: React.ReactElement;
  title?: string;
  active?: boolean;
  children?: React.ReactNode;
  isNotification?: boolean;
}
const GroupMenu = ({ active, icon, title, children, isNotification }: GroupMenuProps) => {
  const classes = useNavStyles(active);
  const { badge } = useNotification();
  return (
    <div className={classes.ulStyled}>
      <div className={classes.ulDivStyled}>
        {isNotification ? (
          <StyledBadge badgeContent={badge > 99 ? `+99` : badge} color="primary">
            {icon}
          </StyledBadge>
        ) : (
          icon
        )}
        <Typography
          variant="h6"
          style={{
            color: active ? "#38c0ea" : "#70748f",
            marginLeft: "20px",
            width: "max-content",
          }}
        >
          {title}
        </Typography>
      </div>
      <div className={classes.expendIcon}>{children}</div>
    </div>
  );
};

export default function FullScreenDialog({ open, handleClose }: DialogProps) {
  const logo = process.env.REACT_APP_PAPS_GIFT === "true" ? papsChristmasLogo : mypaps_logo;
  const navigation = useNavigate();
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const { text } = useText();
  const [isShow, setIsShow] = React.useState(false);
  const [isProfile, setIsProfile] = React.useState(false);
  const [isShowCash, setIsShowCash] = React.useState(false);
  const classes = useNavStyles();
  const { user } = useCurrentUser();

  const [currentLangage, setCurrentLangage] = React.useState("EN");
  React.useEffect(() => {
    setCurrentLangage(i18n.language.toUpperCase());
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (lng === "en") {
      setCurrentLangage("EN");
      handleClose();
    } else {
      setCurrentLangage("FR");
      handleClose();
    }
  };

  React.useEffect(() => {
    if (open) {
      handleClose();
    }
  }, [value]);

  const toggleCollapse = () => {
    setIsShow(!isShow);
    if (isProfile || isShowCash) {
      setIsProfile(false);
      setIsShowCash(false);
    }
  };
  const toggleProfilsCollapse = () => {
    setIsProfile(!isProfile);
    if (isShow || isShowCash) {
      setIsShow(false);
      setIsShowCash(false);
    }
  };
  const toggleCashCollapse = () => {
    setIsShowCash(!isShowCash);
    if (isShow || isProfile) {
      setIsShow(false);
      setIsProfile(false);
    }
  };

  React.useEffect(() => {
    if (location.pathname.includes("tracking")) {
      setValue(1);
    } else if (location.pathname.includes("catalog")) {
      setValue(2);
    } else if (location.pathname.includes("history")) {
      setValue(3);
    } else if (location.pathname.includes("gift")) {
      setValue(4);
    } else if (location.pathname.includes("cash")) {
      setValue(5);
    } else if (location.pathname.includes("notification")) {
      setValue(6);
    } else if (
      location.pathname.includes("users") ||
      location.pathname.includes("client") ||
      location.pathname.includes("address")
    ) {
      setValue(7);
    } else {
      setValue(0);
    }
  }, [location.pathname, value]);

  const homePage = () => navigation("/");
  const requestPage = () => {
    navigation("/tracking/request");
    setIsShow(false);
          handleClose();

  };
  const taskPage = () => {
    navigation("/tracking/task");
    setIsShow(false);
          handleClose();

  };
  const parcelPage = () => {
    navigation("/tracking/parcels");
    setIsShow(false);
          handleClose();

  };
  const catalogPage = () => {
    navigation("/catalog");
    setIsShow(false);
          handleClose();

  };
  const historyPage = () => {
    navigation("/history");
    setIsShow(false);
          handleClose();

  };
  const giftPage = () => {
    navigation("/gifts");
    setIsShow(false);
          handleClose();

  };

  const myProfilePage = () => {
    navigation("/users/profile");
    setIsShow(false);
  };
  const myClientsPage = () => {
    navigation("/client");
    setIsShow(false);
  };
  const usersPage = () => {
    navigation("/users");
    setIsShow(false);
  };
  const addressPage = () => {
    navigation("/address");
    setIsShow(false);
          handleClose();

  };
  const handleOut = () => {
    navigation("/logout");
    setIsShow(false);
          handleClose();

  };
  const notificationPage = () => {
    navigation("/notification");
    setIsShow(false);
          handleClose();

  };
  const handleRemittance = () => {
    navigation("/cash/remittance");
    setIsShow(false);
          handleClose();

  };
  const handleRecap = () => {
    navigation("/cash/recap");
    setIsShow(false);
          handleClose();

  };

  return (
    <div>
      <MuiDialog fullScreen open={open} onClose={handleClose} TransitionComponent={SlideTransition}>
        <AppBar position="relative" className={classes.appBar}>
          <Toolbar>
            <IconButton onClick={homePage}>
              <img src={logo} alt="paps logo" className={classes.logoStyled} />
            </IconButton>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              className={classes.iconButtonStyle}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <List className={classes.ulListStyle}>
          <MenuItem onClick={homePage} style={{ backgroundColor: value === 0 ? "#131939" : "#1a224b" }}>
            <GroupMenu
              active={value === 0}
              icon={<DashIcon color={value === 0 ? "#38c0ea" : "#70748f"} />}
              title={text.all.home}
            />
          </MenuItem>
          <MenuItem style={{ backgroundColor: value === 1 ? "#131939" : "#1a224b" }} onClick={toggleCollapse}>
            <GroupMenu
              active={value === 1}
              icon={<BoxNewIcon color={value === 1 ? "#38c0ea" : "#70748f"} />}
              title={text.all.tracking}
            >
              {isShow ? (
                <ExpandMoreIcon className={classes.iconStyle} />
              ) : (
                <ExpandLessIcon className={classes.iconStyle} />
              )}
            </GroupMenu>
          </MenuItem>
          {isShow && (
            <div className={classes.collapsed}>
              <CollapseItem onClick={requestPage}>{text.all.request}</CollapseItem>
              <CollapseItem onClick={taskPage}>{text.all.task}</CollapseItem>
              <CollapseItem onClick={parcelPage}>{text.all.parcels}</CollapseItem>
            </div>
          )}

          {process.env.REACT_APP_PAPS_PRODUCTS_CHECK === "false" && (
            <MenuItem onClick={catalogPage} style={{ backgroundColor: value === 2 ? "#131939" : "#1a224b" }}>
              <GroupMenu
                active={value === 2}
                icon={<BoxesIcon color={value === 2 ? "#38c0ea" : "#70748f"} />}
                title={text.all.catalog}
              />
            </MenuItem>
          )}
          <MenuItem onClick={historyPage} style={{ backgroundColor: value === 3 ? "#131939" : "#1a224b" }}>
            <GroupMenu
              active={value === 3}
              icon={<HistoryIcon color={value === 3 ? "#38c0ea" : "#70748f"} />}
              title={text.all.history}
            />
          </MenuItem>

          {process.env.REACT_APP_PAPS_GIFT === "true" && (
            <MenuItem onClick={giftPage} style={{ backgroundColor: value === 4 ? "#131939" : "#1a224b" }}>
              <GroupMenu
                active={value === 4}
                icon={<GiftIcon color={value === 4 ? "#38c0ea" : "#70748f"} />}
                title={text.all.gift}
              />
            </MenuItem>
          )}
          <MenuItem style={{ backgroundColor: value === 5 ? "#131939" : "#1a224b" }} onClick={toggleCashCollapse}>
            <GroupMenu
              active={value === 5}
              icon={<BoxNewIcon color={value === 5 ? "#38c0ea" : "#70748f"} />}
              title="Cash"
            >
              {isShow ? (
                <ExpandMoreIcon className={classes.iconStyle} />
              ) : (
                <ExpandLessIcon className={classes.iconStyle} />
              )}
            </GroupMenu>
          </MenuItem>
          {isShowCash && (
            <div className={classes.collapsed}>
              <CollapseItem onClick={handleRecap}>Cash</CollapseItem>
              <CollapseItem onClick={handleRemittance}>{text.cash_management.remittance}</CollapseItem>
            </div>
          )}
          <MenuItem onClick={notificationPage} style={{ backgroundColor: value === 6 ? "#131939" : "#1a224b" }}>
            <GroupMenu
              active={value === 6}
              icon={<RingIcon height={20} width={20} color={value === 6 ? "#38c0ea" : "#70748f"} />}
              title="Notifications"
              isNotification
            />
          </MenuItem>
          <MenuItem style={{ backgroundColor: value === 7 ? "#131939" : "#1a224b" }} onClick={toggleProfilsCollapse}>
            <GroupMenu
              active={value === 7}
              icon={<PersonIcon color={value === 7 ? "#38c0ea" : "#70748f"} />}
              title="Profile"
            >
              {isProfile ? (
                <ExpandMoreIcon className={classes.iconStyle} />
              ) : (
                <ExpandLessIcon className={classes.iconStyle} />
              )}
            </GroupMenu>
          </MenuItem>
          {isProfile && (
            <>
              <div className={classes.collapsedProfile}>
                <CollapseItem >
                  <Grid xs={2}>
                    <Avatar alt="avatar" src={AvatarIcon} />
                  </Grid>
                  <Grid xs={5} className={classes.userGrid}>
                    <span>
                      {user
                        ? `${user.company_user_firstname.substring(0, 5)}.. ${user.company_user_lastname.substring(
                            0,
                            3
                          )}...`
                        : ""}
                    </span>
                    <span className={classes.jobSpan}>{user ? user.company_user_job : ""}</span>
                  </Grid>
                  <Grid xs={5} className={classes.gridCheckbox}>
                    <StyledCheckbox
                      checked={currentLangage === "EN"}
                      onChange={() => changeLanguage("en")}
                      className={classes.checkbox}
                    />
                    <p style={{ color: currentLangage === "EN" ? COLORS.primary : COLORS.secondary }}>EN</p>
                    <StyledCheckbox
                      checked={currentLangage === "FR"}
                      onChange={() => changeLanguage("fr")}
                      className={classes.checkbox}
                    />
                    <p style={{ color: currentLangage === "FR" ? COLORS.primary : COLORS.secondary }}>FR</p>
                  </Grid>
                </CollapseItem>
                <CollapseItem onClick={myProfilePage}>
                  <Grid container className={classes.items}>
                    <Grid xs={10}>{text.all.my_profile}</Grid>
                    <Grid xs={2}>
                      <ChevronRight />
                    </Grid>
                  </Grid>
                </CollapseItem>
                <CollapseItem onClick={myClientsPage}>
                  <Grid container className={classes.items}>
                    <Grid xs={10}>{text.all.my_clients}</Grid>
                    <Grid xs={2}>
                      <ChevronRight />
                    </Grid>
                  </Grid>
                </CollapseItem>
                <CollapseItem onClick={usersPage}>
                  <Grid container className={classes.items}>
                    <Grid xs={10}>{text.all.users}</Grid>
                    <Grid xs={2}>
                      <ChevronRight />
                    </Grid>
                  </Grid>
                </CollapseItem>
                <CollapseItem onClick={addressPage}>
                  <Grid container className={classes.items}>
                    <Grid xs={10}>{text.all.address}</Grid>
                    <Grid xs={2}>
                      <ChevronRight />
                    </Grid>
                  </Grid>
                </CollapseItem>
                <div className={classes.logOut} onClick={handleOut}>
                  <LogOutIcon /> &nbsp;&nbsp;<p>{text.all.logout}</p>
                </div>
              </div>
            </>
          )}
        </List>
      </MuiDialog>
    </div>
  );
}
